"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderStrategies = void 0;
var compareNumbers = function (elementA, elementB) {
    return elementA >= elementB ? 1 : -1;
};
var compareDates = function (elementA, elementB) {
    return elementA.getTime() >= elementB.getTime() ? 1 : -1;
};
var compareStrings = function (elementA, elementB) {
    return elementA.localeCompare(elementB);
};
var minorToMayor = function (elementA, elementB) {
    var typeOfElementA = typeof elementA;
    var typeOfElementB = typeof elementB;
    if (typeOfElementA === "number" && typeOfElementB === "number") {
        return compareNumbers(elementA, elementB);
    }
    else if (elementA instanceof Date && elementB instanceof Date) {
        return compareDates(elementA, elementB);
    }
    else if (typeOfElementA === "string" && typeOfElementB === "string") {
        return compareStrings(elementA, elementB);
    }
    return 0;
};
exports.orderStrategies = {
    minor: minorToMayor,
};
//# sourceMappingURL=orderStrategy.js.map